module.exports = __webpack_public_path__ + "img/5.c807cbcc.png";